//请自行添加语言资源
const landStatistics = {
  beginTime:'开始日期',
  endTime:'结束日期',
  idCardName:'售粮人姓名',
  idCardNo:'售粮人身份证号',
  certNo:'土地承包经营权证',
  contractNo:'合同号',
  muNum:'承包亩数',
  firstParty:'出租方姓名',
};
export default landStatistics



// WEBPACK FOOTER //
// ./src/page/report/landStatistics/lang/landStatistics.zh.js